const a = {
  id: "ArkansasNaturalStateJackpot",
  name: "Natural State Jackpot",
  style: {
    colorPrimary: "#005cb9"
  }
};
export {
  a as default
};
